import { computed, Injectable, signal } from '@angular/core';

// TODO: scope favorites per cash register — they live under one global localStorage
// key, so every workstation sharing a device sees the same list
@Injectable()
export default class FavoriteProductService {
  readonly #favoriteProductIds = signal<number[]>(this.loadFavoriteProductIds());

  readonly favoriteProductIds = computed(() => {
    return this.#favoriteProductIds();
  });

  loadFavoriteProductIds() {
    const favoriteProductIds = localStorage.getItem('favoriteProductIds');
    if (favoriteProductIds) {
      return JSON.parse(favoriteProductIds);
    } else {
      return [];
    }
  }

  addFavoriteProductId(productId: number) {
    const favoriteProductIds = this.#favoriteProductIds();
    if (favoriteProductIds.includes(productId)) {
      return;
    }
    this.#favoriteProductIds.set([...favoriteProductIds, productId]);
    localStorage.setItem(
      'favoriteProductIds',
      JSON.stringify(this.#favoriteProductIds())
    );
  }

  removeFavoriteProductId(productId: number) {
    const favoriteProductIds = this.#favoriteProductIds();
    const newFavoriteProductIds = favoriteProductIds.filter((id) => id !== productId);
    this.#favoriteProductIds.set(newFavoriteProductIds);
    localStorage.setItem('favoriteProductIds', JSON.stringify(newFavoriteProductIds));
  }
}
